import ACTIONS from '../actions';

const initialState = {
  // All rooms list
  rooms: [],
  roomsPage: 1,
  roomsPages: 0,
  roomsTotal: 0,
  roomsLoading: false,
  roomsError: null,

  // Single room
  activeRoom: null,
  activeRoomLoading: false,
  activeRoomError: null,

  // Search
  searchResults: [],
  searchTotal: 0,
  searchLoading: false,
  searchError: null,

  // Threads for active prospect
  activeProspect: null,
  threads: [],
  threadsTotal: 0,
  threadsLoading: false,
  threadsError: null,

  // Send message
  sendLoading: false,
  sendError: null,

  // Unread count for inbox badge
  unreadCount: 0,
};

const ConversationsReducer = (state = initialState, action) => {
  switch (action.type) {
    // ─────────────────────────────────────
    // GET ALL ROOMS
    // ─────────────────────────────────────

    case ACTIONS.GET_ALL_ROOMS_REQUEST:
      return {
        ...state,
        roomsLoading: true,
        roomsError: null,
      };
    case ACTIONS.GET_ALL_ROOMS_SUCCESS:
      return {
        ...state,
        roomsLoading: false,
        rooms: action.payload?.data,
        roomsPage: action.payload.page,
        roomsPages: action.payload.pages,
        roomsTotal: action.payload.total,
      };
    case ACTIONS.GET_ALL_ROOMS_FAIL:
      return {
        ...state,
        roomsLoading: false,
        roomsError: action.payload,
      };

    // ─────────────────────────────────────
    // GET SINGLE ROOM
    // ─────────────────────────────────────
    case ACTIONS.GET_SINGLE_ROOM_REQUEST:
      return {
        ...state,
        activeRoomLoading: true,
        activeRoomError: null,
      };
    case ACTIONS.GET_SINGLE_ROOM_SUCCESS:
      return {
        ...state,
        activeRoomLoading: false,
        activeRoom: action.payload,
      };
    case ACTIONS.GET_SINGLE_ROOM_FAIL:
      return {
        ...state,
        activeRoomLoading: false,
        activeRoomError: action.payload,
      };
    // ─────────────────────────────────────
    // SEARCH ROOMS
    // ─────────────────────────────────────
    case ACTIONS.SEARCH_ROOMS_REQUEST:
      return {
        ...state,
        searchLoading: true,
        searchError: null,
      };

    case ACTIONS.SEARCH_ROOMS_SUCCESS:
      return {
        ...state,
        searchLoading: false,
        searchResults: action.payload.data,
        searchTotal: action.payload.total,
      };

    case ACTIONS.SEARCH_ROOMS_FAIL:
      return {
        ...state,
        searchLoading: false,
        searchError: action.payload,
      };

    // ─────────────────────────────────────
    // TOGGLE STAR — update in-place in rooms[]
    // ─────────────────────────────────────
    case ACTIONS.TOGGLE_STAR_ROOM:
      return {
        ...state,
        rooms: state.rooms.map((room) =>
          room._id === action.payload._id ? action.payload : room,
        ),
        // also update activeRoom if it's the same one
        activeRoom:
          state.activeRoom?._id === action.payload._id
            ? action.payload
            : state.activeRoom,
      };

    // ─────────────────────────────────────
    // DELETE ROOM — remove from list
    // ─────────────────────────────────────
    case ACTIONS.DELETE_ROOM:
      return {
        ...state,
        rooms: state.rooms.filter((room) => room._id !== action.payload),
        activeRoom:
          state.activeRoom?._id === action.payload ? null : state.activeRoom,
        roomsTotal: state.roomsTotal - 1,
      };

    // ─────────────────────────────────────
    // GET THREADS
    // ─────────────────────────────────────
    case ACTIONS.GET_THREADS_REQUEST:
      return {
        ...state,
        threadsLoading: true,
        threadsError: null,
        threads: [], // clear previous threads when switching prospect
      };

    case ACTIONS.GET_THREADS_SUCCESS:
      return {
        ...state,
        threadsLoading: false,
        threads: action.payload.data,
        threadsTotal: action.payload.total,
        activeProspect: action.activeProspect,
      };

    case ACTIONS.GET_THREADS_FAIL:
      return {
        ...state,
        threadsLoading: false,
        threadsError: action.payload,
      };

    // ─────────────────────────────────────
    // SEND MESSAGE
    // ─────────────────────────────────────
    case ACTIONS.SEND_MESSAGE_REQUEST:
      return {
        ...state,
        sendLoading: true,
        sendError: null,
      };

    case ACTIONS.SEND_MESSAGE_SUCCESS: {
      const { threads: newThreads, room } = action.payload;
      return {
        ...state,
        sendLoading: false,
        // Append new outbound threads to thread list
        threads: [...state.threads, ...action.payload.threads],
        // Update room in list with latest message info
        //rooms: state.rooms.map((r) => (r._id === room._id ? room : r)),
        // activeRoom: room,
      };
    }

    case ACTIONS.SEND_MESSAGE_FAIL:
      return {
        ...state,
        sendLoading: false,
        sendError: action.payload,
      };
    case ACTIONS.SET_ACTIVE_PROSPECT:
      return {
        ...state,
        activeProspect: action.payload.prospect,
        rooms: [action.payload.newRoom, ...state.rooms],
      };
    default:
      return state;
  }
};

export default ConversationsReducer;
